import { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Exchanges the Emergent OAuth session_id (URL fragment) for a SAFE admin
 * session cookie, then lands the admin in the console.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export const AdminAuthCallback = () => {
  const processed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    if (!sessionId) {
      window.location.replace('/admin');
      return;
    }

    const exchange = async () => {
      try {
        await axios.post(`${API}/network/auth/session`, { session_id: sessionId },
          { withCredentials: true });
        window.history.replaceState(null, '', '/admin');
        window.location.replace('/admin');
      } catch (err) {
        const detail = err?.response?.data?.detail;
        setError(typeof detail === 'string' ? detail : 'Sign-in could not be completed.');
      }
    };
    exchange();
  }, []);

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4" data-testid="admin-auth-callback">
      <div className="bg-white w-full max-w-md p-10">
        {error ? (
          <>
            <h1 className="text-lg font-bold text-slate-900 mb-3">Sign-in refused</h1>
            <p className="text-sm text-slate-600 leading-relaxed" data-testid="admin-auth-error">{error}</p>
            <a href="/admin" className="btn-primary inline-block mt-6">Back to sign in</a>
          </>
        ) : (
          <p className="text-sm text-slate-500" data-testid="admin-auth-working">Completing sign-in…</p>
        )}
      </div>
    </div>
  );
};

export default AdminAuthCallback;
